import { withLayout } from 'pages/Layout'
import PrivacyPolicy from './PrivacyPolicy'

export default withLayout('Privacy Policy', PrivacyPolicy)
